import { Col, DatePicker, Form, Select, Tag } from "antd"
import { useState } from "react";
import { customLocalDateFormat } from "../../atoms/time";
import './GoogleReviews.css';

export default function SelectPeriod({setSelectedType, defaultValue}) {
    
  const [selectedOption, setSelectedOption] = useState(defaultValue || 'ALL');
  const [selectedRange, setSelectedRange] = useState(null);

  const handleChange = (value) => {
    setSelectedOption(value);
    setSelectedRange(null); 
    
    if (value !== 'CUSTOM_RANGE' && setSelectedType) {
      setSelectedType(value); 
    }
  };

  const handleRangeChange = (dates, dateStrings) => {
    setSelectedRange(dates);
    setSelectedOption('CUSTOM_RANGE'); 
    
    if (setSelectedType) {
      setSelectedType('CUSTOM_RANGE' + dates.map((date) => date.format('DD-MM-YYYY'))); 
    }
  };

    return (
        <div>
           <div>
                <Select  //open={false} 
                    onChange={handleChange}
                    value={selectedOption}
                    variant={false}                    
                    className="select-link-style"
                    style={{ minWidth: '180px', fontWeight: 'bold', fontSize: '16px', textAlign:'right' }} >

                    <Select.Option value='ALL'><span style={{color:'black'}}>Desde el Inicio</span></Select.Option>        
                    <Select.Option value='CURRENT_MONTH'>Mes Actual</Select.Option>
                    <Select.Option value='PREVIOUS_MONTH'>Mes Anterior</Select.Option>
                    <Select.Option value='LAST_7DAYS'>Últimos 7 días</Select.Option>
                    <Select.Option value='LAST_30DAYS'>Últimos 30 días</Select.Option>
                    <Select.Option value='LAST_3MONTHS'>Últimos 3 meses</Select.Option>
                    <Select.Option value='LAST_12MONTHS'>Últimos 12 meses</Select.Option>
                    <Select.Option value="CUSTOM_RANGE">Rango Personalizado</Select.Option>

                </Select>
            </div> 

        {selectedOption === 'CUSTOM_RANGE' && (
            <div> 
                <DatePicker.RangePicker		
                    format={(customLocalDateFormat)}
                    size="small"
                    style={{ marginLeft: 10 }}
                    onChange={handleRangeChange}
                    value={selectedRange}/>
            </div> 
        )}
        </div>
    )
}

